module.exports = __webpack_public_path__ + "static/media/projecttree.a872fd66.png";